export var FragmentFlag;
(function (FragmentFlag) {
    FragmentFlag[FragmentFlag["DontFragment"] = 0] = "DontFragment";
    FragmentFlag[FragmentFlag["MoreFragments"] = 1] = "MoreFragments";
    FragmentFlag[FragmentFlag["EndFragment"] = 2] = "EndFragment";
})(FragmentFlag || (FragmentFlag = {}));
